const DEFAULT_ACCENT = '#00664e';

export const OFFICE_COLOR_PRESETS = [
  { name: 'أخضر', value: '#00664e' },
  { name: 'ذهبي', value: '#8a6613' },
  { name: 'أزرق', value: '#245b91' },
  { name: 'خمري', value: '#923f52' },
  { name: 'فيروزي', value: '#137c80' },
];

export function safeOfficeLogo(value) {
  try {
    const url = new URL(String(value || ''));
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
  } catch {
    return '';
  }
}

const OFFICE_SLUG = /^[a-z][a-z0-9-]{2,47}$/;

export function publicOfficeSlug(pathname, search = '') {
  const fromPath = String(pathname || '').match(/^\/office\/([^/]+)\/?$/)?.[1];
  const fromGuide = /^\/guide(?:\/|$)/.test(pathname || '') ? new URLSearchParams(search).get('office') : '';
  const slug = fromPath || fromGuide || '';
  return OFFICE_SLUG.test(slug) ? slug : '';
}

export function officePublicPath(path, slug) {
  if (!OFFICE_SLUG.test(slug || '') || !String(path).startsWith('/') || String(path).startsWith('//')) return path;
  const target = new URL(path, 'https://n9.invalid');
  if (target.origin !== 'https://n9.invalid') return path;
  if (target.pathname === '/' || target.pathname === '/login') {
    target.pathname = `/office/${slug}`;
    target.searchParams.delete('office');
  } else if (/^\/guide(?:\/|$)/.test(target.pathname)) {
    target.searchParams.set('office', slug);
  } else {
    return path;
  }
  return `${target.pathname}${target.search}${target.hash}`;
}

function luminance(color) {
  const channels = color.match(/[a-f0-9]{2}/gi).map(channel => {
    const value = parseInt(channel, 16) / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
}

function darken(color, factor) {
  return '#' + color.match(/[a-f0-9]{2}/gi).map(channel => Math.round(parseInt(channel, 16) * factor).toString(16).padStart(2, '0')).join('');
}

export function officeBrandTheme(office) {
  const accent = /^#[a-f0-9]{6}$/i.test(office?.accent_color || '') ? office.accent_color.toLowerCase() : DEFAULT_ACCENT;
  const whiteContrast = 1.05 / (luminance(accent) + 0.05);
  const contrast = whiteContrast >= 4.5 ? '#ffffff' : '#111b18';
  let ink = accent;
  while (1.05 / (luminance(ink) + 0.05) < 4.5) ink = darken(ink, 0.85);
  const nameLength = Array.from(String(office?.name || '')).length;
  return {
    '--office-accent': accent,
    '--office-on-accent': contrast,
    '--office-brand-ink': ink,
    '--office-name-size': nameLength > 90 ? '11px' : nameLength > 55 ? '12px' : '14px',
    '--office-header-height': `${(nameLength > 90 ? 144 : nameLength > 55 ? 112 : 88)+(office?.subscription?32:0)}px`,
    '--accent': accent,
    '--accent-contrast': contrast,
    '--accent-strong': contrast === '#ffffff' ? darken(accent, 0.86) : accent,
    '--accent-soft': `color-mix(in srgb, ${accent} 9%, var(--surface, white))`,
    '--accent-tint': `color-mix(in srgb, ${accent} 6%, var(--surface, white))`,
  };
}
